import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isNumeric,
  isNonEmptyString,
  createCustomPropType,
} from '../../../js/app/react/validators';

class AdvWorkflowView extends Component {
  UNSAFE_componentWillMount() {
    const { clientId } = this.props;
    if (!isNumeric(clientId))
      throw new Error('clientId must be numeric when constructing the workflow tree');
  }

  componentDidMount() {
    const { clientId, steps, branch, workflowId, extendTree } = this.props;
    steps.forEach((_, index) => {
      extendTree(branch.concat(index), workflowId, clientId);
    });
  }

  render() {
    const { steps, branch, workflowId } = this.props;
    return (
      <div>
        {steps.map((Step, index) => {
          const stepBranch = branch.concat(index);
          return (
            <Step key={JSON.stringify(stepBranch)} branch={stepBranch} workflowId={workflowId} />
          );
        })}
      </div>
    );
  }
}

AdvWorkflowView.propTypes = {
  clientId: createCustomPropType(isNumeric).isRequired,
  steps: PropTypes.arrayOf(PropTypes.func).isRequired,
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  extendTree: PropTypes.func.isRequired,
};

export default AdvWorkflowView;
